var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useSelector } from 'react-redux';
import { count, get, list, create, update, remove, upsert, multiUpsert } from './crud';
import Operations from './operations';
import customToast, { TYPE } from '../toast/toast';
const useCRUD = (featureEnum) => {
    const token = useSelector((s) => s.TOKEN);
    const validate = (response, error, success) => {
        if (!error && !success)
            return response;
        const isValid = () => {
            return !!response;
        };
        if (success) {
            if (typeof success === 'string') {
                if (isValid()) {
                    customToast(TYPE.SUCCESS, success);
                    return response;
                }
            }
            else if (typeof success === 'function') {
                const message = success(response);
                if (message) {
                    customToast(TYPE.SUCCESS, message);
                    return response;
                }
            }
        }
        if (error) {
            if (typeof error === 'string') {
                if (!isValid()) {
                    customToast(TYPE.ERROR, error);
                    return false;
                }
            }
            else if (typeof error === 'function') {
                const message = error(response);
                if (message) {
                    customToast(TYPE.ERROR, message);
                    return false;
                }
            }
        }
        return response;
    };
    const caller = (crudFunction, ...props) => () => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield crudFunction(...props);
        return result;
    });
    const init = (operation) => (payload, error, success, sortArgument, pageIndex) => __awaiter(void 0, void 0, void 0, function* () {
        const mapping = {
            [Operations.COUNT]: caller(count, token, featureEnum, payload),
            [Operations.GET]: caller(get, token, featureEnum, payload),
            [Operations.LIST]: caller(list, token, featureEnum, payload, sortArgument, pageIndex),
            [Operations.CREATE]: caller(create, token, featureEnum, payload),
            [Operations.UPDATE]: caller(update, token, featureEnum, payload),
            [Operations.DELETE]: caller(remove, token, featureEnum, payload),
            [Operations.UPSERT]: caller(upsert, token, featureEnum, payload),
            [Operations.MULTI_UPSERT]: caller(multiUpsert, token, featureEnum, payload),
        };
        const response = yield mapping[operation]();
        const validatedResponse = validate(response, error, success);
        return validatedResponse;
    });
    return {
        count: init(Operations.COUNT),
        get: init(Operations.GET),
        list: init(Operations.LIST),
        create: init(Operations.CREATE),
        update: init(Operations.UPDATE),
        remove: init(Operations.DELETE),
        upsert: init(Operations.UPSERT),
        multiUpsert: init(Operations.MULTI_UPSERT),
    };
};
export default useCRUD;
